import { render, staticRenderFns } from "./InputButtonDialog.vue?vue&type=template&id=ff1b6b52"
import script from "./InputButtonDialog.vue?vue&type=script&lang=js"
export * from "./InputButtonDialog.vue?vue&type=script&lang=js"
import style0 from "./InputButtonDialog.vue?vue&type=style&index=0&id=ff1b6b52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports